import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import Modal from '@/components/Modal/Modal';
import Button from '@/components/Button/Button';
import { DownloadSignedUrlFile } from '@/lib/download';

const FailedFilesModal = ({
  open,
  files,
  onClose,
  onRetry,
}: {
  open: boolean;
  files: DownloadSignedUrlFile[];
  onClose: () => void;
  onRetry: () => void;
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={
        <FormattedMessage
          id="failedFilesTitle"
          defaultMessage="Failed files"
        />
      }
      actions={
        <>
          <Button
            variant="text"
            onClick={onClose}
            aria-label="Close Button"
          >
            <FormattedMessage id="close" defaultMessage="Close" />
          </Button>
          <Button
            variant="contained"
            onClick={onRetry}
            aria-label="Retry Button"
          >
            <FormattedMessage id="retry" defaultMessage="Retry" />
          </Button>
        </>
      }
    >
      <Description>
        <FormattedMessage
          id="failedFilesModalMessage"
          defaultMessage="{count, plural, one {# file} other {# files}} failed to download:"
          values={{ count: files.length }}
        />
      </Description>
      <FileList>
        {files.map((file, index) => (
          <FileRow key={`${file.path || file.url}-${index}`}>
            {file.name || file.path}
          </FileRow>
        ))}
      </FileList>
    </Modal>
  );
};

const Description = styled('div')(({ theme }) => ({
  fontSize: 14,
  lineHeight: '20px',
  marginBottom: theme.spacing(2),
}));

const FileList = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  maxHeight: 260,
  overflowY: 'auto',
}));

const FileRow = styled('div')(({ theme }) => ({
  fontSize: 14,
  lineHeight: '20px',
  padding: '10px 16px',
  borderRadius: theme.radii.xxs,
  border: `1px solid ${theme.palette.grey200}`,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export default FailedFilesModal;
